import Vue from 'vue';
import Component from 'vue-class-component';
import { Authority } from '@/shared/security/authority';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);
import Router, { RouteConfig } from 'vue-router';

const Home = () => import('@/core/home/home.vue');
const Error = () => import('@/core/error/error.vue');
const Dashboard = () => import('@/core/Contratos/Dashboard/Dashboard.vue');
import account from '@/router/account';
import admin from '@/router/admin';
import entities from '@/router/entities';
import pages from '@/router/pages';

Vue.use(Router);

// prettier-ignore
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Dashboard',
      name: 'Dashboard',
      component: () => import('@/core/Contratos/Dashboard/Dashboard.vue'),
      meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Modulos',
      name: 'Modulos',
      component: () => import('@/core/Contratos/Modulos/Modulos.vue'),
      props: (route) => ({modulo: route.query.modulo}),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Formularios',
      name: 'Formularios',
      component: () => import('@/core/Contratos/Formularios/Formularios.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
        {
      path: '/Documentosalta/tipo/',
      name: 'Documentosalta',
      component: () => import('@/core/Contratos/Formularios/Documentosalta.vue'),
              props: route => ({
    id_tipo_cuest: Number(route.query.id_tipo_cuest)
  }),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Documentoscontratos',
      name: 'Documentoscontratos',
      component: () => import('@/core/Contratos/Formularios/Documentoscontratos.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/ReporteOrdenes',
      name: 'ReporteOrdenes',
      component: () => import('@/core/Reportes/Ordenes/ReporteOrdenes.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/ReportePosCuenta',
      name: 'ReportePosCuenta',
      component: () => import('@/core/Reportes/PosicionCuenta/ReportePosCuenta.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/ReportePosInter',
      name: 'ReportePosInter',
      component: () => import('@/core/Reportes/PosicionIntermediario/ReportePosInter.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Posicion',
      name: 'Posicion',
      component: () => import('@/core/Operaciones/Posicion/Posicion.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Reportes',
      name: 'Reportes',
      component: () => import('@/core/Reportes/Reportes.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/CargaInformeMensual',
      name: 'CargaInformeMensual',
      component: () => import('@/core/Carga/PantallaCarga/CargaInformeMensual.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Carga',
      name: 'Carga',
      component: () => import('@/core/Carga/PantallaCarga/Carga.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Estadistica',
      name: 'Estadistica',
      component: () => import('@/core/Carga/PantallaCarga/Estadistica.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Actualizacion',
      name: 'Actualizacion',
      component: () => import('@/core/Carga/PantallaCarga/Actualizacion.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Errores',
      name: 'Errores',
      component: () => import('@/core/Carga/PantallaCarga/Errores.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Carga Tipos',
      name: 'Carga Tipos',
      component: () => import('@/core/Carga/PantallaCarga/Carga Tipos.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/CargaManual',
      name: 'CargaManual',
      component: () => import('@/core/Carga/PantallaCarga/CargaManual.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/CargaManualValuacion',
      name: 'CargaManualValuacion',
      component: () => import('@/core/Carga/PantallaCarga/CargaManualValuacion.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
        {
      path: '/CargaDiariaManualValuacion',
      name: 'CargaDiariaManualValuacion',
      component: () => import('@/core/Carga/PantallaCarga/CargaManualValuacionNuevos.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
        {
      path: '/CargaManualMovtos',
      name: 'CargaManualMovtos',
      component: () => import('@/core/Carga/PantallaCarga/CargaManualMovtos.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },

            {
      path: '/CargaMovtosDiarios',
      name: 'CargaMovtosDiarios',
      component: () => import('@/core/Carga/PantallaCarga/CargaManualMovtosNuevos.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
            {
      path: '/CargaManualPosicion',
      name: 'CargaManualPosicion',
      component: () => import('@/core/Carga/PantallaCarga/CargaManualPosicion.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
                {
      path: '/CargaDiariaManualPosicion',
      name: 'CargaDiariaManualPosicion',
      component: () => import('@/core/Carga/PantallaCarga/CargaManualPosicionNuevos.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
                {
      path: '/CargaManualGeneral',
      name: 'CargaManualGeneral',
      component: () => import('@/core/Carga/PantallaCarga/CargaManualGeneral.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Carga General',
      name: 'Carga General',
      component: () => import('@/core/Carga/PantallaCarga/Carga General.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/ConsultaPosicion',
      name: 'ConsultaPosicion',
      component: () => import('@/core/Operaciones/ConsultaOperaciones/ConsultaPosicion.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
        {
      path: '/ConsultaInformacionMovtos',
      name: 'ConsultaInformacionMovtos',
      component: () => import('@/core/Operaciones/ConsultaInformacionCargada/ConsultaInformacionMovtos.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
            {
      path: '/ConsultaInformacionVectores',
      name: 'ConsultaInformacionVectores',
      component: () => import('@/core/Operaciones/ConsultaInformacionCargada/ConsultaInformacionVectores.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },

                {
      path: '/ConsultasInformacion',
      name: 'ConsultasInformacion',
      component: () => import('@/core/Operaciones/ConsultaInformacionCargada/ConsultasInformacion.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },

                    {
      path: '/ConsultaPosicionesTotales',
      name: 'ConsultaPosicionesTotales',
      component: () => import('@/core/Operaciones/ConsultaInformacionCargada/ConsultaPosicionesTotales.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },

     {
      path: '/ConsultaInformacionCuentas',
      name: 'ConsultaInformacionCuentas',
      component: () => import('@/core/Operaciones/ConsultaInformacionCargada/ConsultaInformacionCuentas.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },

         {
      path: '/ConsultaInformacionCuentasConsultadas',
      name: 'ConsultaInformacionCuentasConsultadas',
      component: () => import('@/core/Operaciones/ConsultaInformacionCargada/ConsultaInformacionCuentasConsultadas.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },

    
    
    {
      path: '/OrdenesGlobales',
      name: 'OrdenesGlobales',
      component: () => import('@/core/Operaciones/OrdenesGlobales/OrdenesGlobales.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/ReportesVisor',
      name: 'ReportesVisor',
      component: () => import('@/core/ReportesVisor/ReportesVisor.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/ConsultaReportes/:id_nodo/:menu_id/:descripcion/:submenu',
      name: 'ConsultaReportes',
      component: () => import('@/core/ReportesVisor/ConsultaReportes.vue'),
      props:true,
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path:     '/MantenimientoDatos/catalogos/:id_nodo/:menu_id/:descripcion',
      name: 'Catalogos',
      component: () => import('@/core/MantenimientoDatos/Catalogos.vue'),
      props:true,
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
        {
      path: '/MantenimientoDatos/submenus/:id_nodo/:menu_id/:modulo_id/:descripcion_menu/:descripcion_modulo',
      name: 'SubmenusCatalogos',
      component: () => import('@/core/MantenimientoDatos/SubmenusCatalogos.vue'),
      props:true,
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/InformeMensual',
      name: 'InformeMensual',
      component: () => import('@/core/ReportesVisor/InformeMensual.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/MenuCatalogos',
      name: 'MenuCatalogos',
      component: () => import('@/core/MantenimientoDatos/MenuCatalogos.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Globales',
      name: 'Grupos Globales y contratos',
      component: () => import('@/core/MantenimientoDatos/MantenimientoGlobales.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    
    {
      path: '/ReportesdeResultados',
      name: 'ReportesdeResultados',
      component: () => import('@/core/ReportesVisor/ReportesdeResultados.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },

    {
      path: '/ReportesdeOperaciones',
      name: 'ReportesdeOperaciones',
      component: () => import('@/core/ReportesVisor/ReportesdeOperaciones.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/ReportesdeApoyo',
      name: 'ReportesdeApoyo',
      component: () => import('@/core/ReportesVisor/ReportesdeApoyo.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/ResumendePortafolio',
      name: 'ResumendePortafolio',
      component: () => import('@/core/ReportesVisor/ResumendePortafolio.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/EstadosdeResultados',
      name: 'EstadosdeResultados',
      component: () => import('@/core/ReportesVisor/EstadosdeResultados.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/MenuReportes',
      name: 'MenuReportes',
      component: () => import('@/core/ReportesVisor/MenuReportes.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/SubMenuReportes/:id_nodo/:menu_id/:descripcion',
      name: 'SubMenuReportes',
      component: () => import('@/core/ReportesVisor/SubMenuReportes.vue'),
      props: true,
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Cuestionarios',
      name: 'Cuestionarios',
      component: () => import('@/core/Contratos/Cuestionarios/Cuestionarios.vue'),
      props: (route) => ({solicitud: route.query.solicitud, modulo: route.query.modulo}),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    }, 
    {
      path: '/Portafolios',
      name: 'Portafolios',
      component: () => import('@/core/Contratos/AltaPF/Portafolios.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/PortafoliosClientes',
      name: 'PortafoliosClientes',
      component: () => import('@/core/Contratos/AltaPF/PortafoliosClientes.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/TipoValor',
      name: 'RiTipoValor',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/RiTipoValor.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
        {
      path: '/RiInformacionValores',
      name: 'RiInformacionValores',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/RiInformacionValores.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
        {
      path: '/VectorValores',
      name: 'VectorValores',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/VectorValores.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Inflacion',
      name: 'Inflacion',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/Inflacion.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
        {
      path: '/ControldeCarga',
      name: 'ControldeCarga',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/ControldeCarga.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
            {
      path: '/ControlCarga',
      name: 'ControlCarga',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/ControlCargaAsesores.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
            {
      path: '/ContratosdeIntermediarios',
      name: 'ContratosdeIntermediarios',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/ContratosdeIntermediarios.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
                {
      path: '/CatalogoClientes',
      name: 'CatalogoClientes',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/Clientes.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
      {
      path: '/CatalogoIntermediarios',
      name: 'CatalogoIntermediarios',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/Intermediarios.vue'),
           meta: {
          authorities: [Authority.ADMIN, Authority.GESTOR,Authority.USER]
        }
    },
    {
      path: '/ClientesContratos',
      name: 'ClientesContratos',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/ClientesContratos.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
        {
      path: '/Despachos',
      name: 'Despachos',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/Despachos.vue'),
           meta: {
          authorities: [Authority.ADMIN, Authority.GESTOR]
        }
    },

            {
      path: '/Direcciones',
      name: 'Direcciones',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/Direcciones.vue'),
           meta: {
          authorities: [Authority.ADMIN, Authority.GESTOR]
        }
    },
                {
      path: '/Promotores',
      name: 'Promotores',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/Promotores.vue'),
           meta: {
          authorities: [Authority.ADMIN, Authority.GESTOR]        }
    },
                    {
      path: '/DireccionesDespachos',
      name: 'DireccionesDespachos',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/DireccionesDespachos.vue'),
           meta: {
          authorities: [Authority.ADMIN, Authority.GESTOR]        }
    },

                        {
      path: '/PromotoresDirecciones',
      name: 'PromotoresDirecciones',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/PromotoresDirecciones.vue'),
           meta: {
          authorities: [Authority.ADMIN, Authority.GESTOR]        }
    },
                        {
      path: '/PersonasPromotores',
      name: 'PersonasPromotores',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/PersonasPromotores.vue'),
           meta: {
          authorities: [Authority.ADMIN, Authority.GESTOR]        }
    },    
    
                    {
      path: '/GruposClientes',
      name: 'GruposClientes',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/GruposClientes.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
                        {
      path: '/CuentasGrupos',
      name: 'CuentasGrupos',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/CuentasGrupos.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
                            {
      path: '/UsuariosPersonasCuentas',
      name: 'UsuariosPersonasCuentas',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/UsuariosPersonasCuentas.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.GESTOR]
        }
    },
                                {
      path: '/GestoresUsuarios',
      name: 'GestoresUsuarios',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/GestoresUsuarios.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.GESTOR]
        }
    },
    
    {
      path: '/ReportesInformeGeneral',
      name: 'ReportesInformeGeneral',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/ReportesInformeGeneral.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/ReportesInformeUsuario',
      name: 'ReportesInformeUsuario',
      component: () => import('@/core/MantenimientoDatos/CatalogosFolder/ReportesInformeUsuario.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/PortafoliosMenu',
      name: 'PortafoliosMenu',
      component: () => import('@/core/Contratos/AltaPF/PortafoliosMenu.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/Clientes',
      name: 'Clientes',
      component: () => import('@/core/Clientes/Clientes.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/ClientesPF',
      name: 'ClientesPF',
      component: () => import('@/core/Clientes/ClientesPF.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/ClientesMenu',
      name: 'ClientesMenu',
      component: () => import('@/core/Clientes/ClientesMenu.vue'),
           meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },
    {
      path: '/AltaPF',
      name: 'AltaPF',
      component: () => import('@/core/Contratos/AltaPF/AltaPF.vue'),
      props: (route) => ({IdTipoCuest: route.query.IdTipoCuest, IdCuestionario: route.query.IdCuestionario,
         BotonEliminar: route.query.BotonEliminar, BotonModificar: route.query.BotonModificar,
         solicitud: route.query.solicitud, modulo: route.query.modulo}),
              meta: {
          authorities: [Authority.ADMIN,Authority.USER, Authority.EJECUTIVO, Authority.GESTOR,Authority.ADMIN, Authority.EJECUTIVO]
        }
    },        
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Error,
      meta: { error403: true }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: Error,
      meta: { error404: true }
    },
    ...account,
    ...admin,
    entities,
    ...pages
  ]
});

export default router;
